import { ContactSlugEnum as a } from "@systemeio/ui";
const i = (s, o) => Object.keys(s).includes(o), l = (s, o) => {
  const t = [];
  return Object.values(a).forEach((r) => {
    const n = i(o, r), c = i(s, r);
    if (!n && c) {
      const e = s[r];
      e && t.push(...e);
    }
  }), t;
};
export {
  l as getMissingFieldsErrors
};
